import React, { useMemo } from 'react';
import _ from 'lodash';

import { Typography } from '@material-ui/core';

import { getPlayerScoreSummaryHistory } from '../../../lib/services/user-action.service';
import { SimpleTable } from '../../_core/_ui/simple-table.component';

const headerRows = [
  { cells: [{ content: "Result Summary", colSpan: 3 }, { content: "Evaluation Summary", colSpan: 4 }] },
  { cells: [{ content: "Status", colSpan: 1 }, { content: "Adjusted", colSpan: 1 }, { content: "Logged At", colSpan: 1 }, { content: "# Evaluators", colSpan: 1 }, { content: "# Scores", colSpan: 1 }, { content: "# Skills", colSpan: 1 }, { content: "# Drills", colSpan: 1 }] },
]

interface IBiasAdjustedScoreHistoryGraphQL {
  playerAssessmentId: string;
}

export const BiasAdjustedScoreHistoryGraphQL: React.FC<IBiasAdjustedScoreHistoryGraphQL> = ({ playerAssessmentId }) => {
  const { scoreSummaryHistory } = getPlayerScoreSummaryHistory({ playerAssessmentId });

  const rows = useMemo(() => _.map(scoreSummaryHistory, ({adjusted, loggedAt, evaluationSummary}, index) => {
    const loggedAtDate = new Date(loggedAt);
    const { numEvaluators, numScores, numSkills, numDrills } = evaluationSummary || {};
    return {
      cells: [
        { content: index === 0 ? "Active" : "" },
        { content: adjusted },
        { content: loggedAtDate.toLocaleString() },
        { content: numEvaluators },
        { content: numScores },
        { content: numSkills },
        { content: numDrills },
      ],
    }
  }), [scoreSummaryHistory])

  if (!scoreSummaryHistory?.length) return <Typography>No data found</Typography>

  return <SimpleTable headerRows={headerRows} rows={rows} highlightedRows={[0]} />
};
